import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import XHR from "i18next-http-backend"

import { resources } from "translations"

const DETECTION_OPTIONS = {
	order: ["navigator"],
}

i18n.use(XHR)
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		detection: DETECTION_OPTIONS,
		resources,
		ns: "common",
		defaultNS: "common",
		lng: "fr",
		fallbackLng: "fr",
		interpolation: {
			escapeValue: false,
		},
		react: {
			//wait: true
		},
	})

export const getLanguage = () => {
	return (
		i18n.language || (typeof window !== "undefined" && window.localStorage.i18nextLng) || "fr"
	)
}

export default i18n
